export default function GetInvolved() {
  return (

    <div
      className="min-h-screen bg-cover bg-center text-gray-800 flex flex-col"
      style={{ backgroundImage: "url('/background50.jpg')" }}
    >
      <main className="flex-grow flex items-center justify-center px-4">
         <div className="bg-white bg-opacity-90 shadow-xl rounded-2xl p-10 max-w-3xl w-full">

          <div className="py-20 px-6 max-w-4xl mx-auto text-center text-olive">
            <h1 className="text-4xl font-bold mb-6">Get Involved</h1>
            <p className="text-lg leading-relaxed mb-8 text-black">
              Whether you’re a composting pro or just getting started, there’s a place for you. Begin collecting compostable material, host a bin, or help spread the word!
            </p>

            <div className="flex flex-col items-center gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61576185584430"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center bg-blue gap-2 text-white bg-accent-blue hover:bg-olive px-5 py-3 rounded-md transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 fill-white" viewBox="0 0 24 24">
                  <path d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-3h2.5V9.5a3.5 3.5 0 0 1 3.7-3.9c1 0 2 .1 2 .1v2.2H15.7c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.5 3h-2.3v7A10 10 0 0 0 22 12z" />
                </svg>
                Follow us on Facebook
              </a>
              <a
                className="text-black"
              >
                Or
              </a>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScadPWCqaEXYT6pzbhW5EcMK0WK9q2x5edfb2B3jDdvY3JV7g/viewform?usp=header"
                className="mt-4 inline-block bg-sienna text-offwhite px-6 py-3 rounded-md hover:bg-olive transition"
              >
                Fill Out this Interest Form
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
